import { env } from '@/constants';

const bucketMapping = {
  document: env.cdn.VITE_DOCUMENTS_IMG_PROXY_BUCKET,
  artwork: env.cdn.VITE_ARTWORK_IMG_PROXY_BUCKET,
  profile: env.cdn.VITE_PROFILE_IMG_PROXY_BUCKET,
};

type BucketTypes = keyof typeof bucketMapping;

interface BaseOptions {
  bucket: BucketTypes;
  options: string;
  extension: string;
}

type CdnOptions = BaseOptions['bucket'] extends 'document' ? Omit<BaseOptions, 'extension'> : BaseOptions;

const _defaultOptions: CdnOptions = { extension: 'webp', bucket: 'artwork', options: 'q:80/rs:fit:2048:2048' };

/**
 * TODO: refactor to remove this & it's usage
 * @deprecated use the url property of the image instead, this is the full url & doesn't need adjusting.
 */
export const cdn = (file: string, config?: Partial<CdnOptions>) => {
  const _config: CdnOptions = { ..._defaultOptions, ...config };
  const bucketUrl = bucketMapping[_config.bucket];

  if (!file) {
    return '/images/artwork-placeholder.png';
  } else if (file.indexOf('/') >= 0) {
    return file;
  }
  const filePath = bucketUrl + '/' + encodeURIComponent(file.replace(/\+/g, '%20'));

  let cdnPath;
  if (_config.bucket === 'document') cdnPath = `/sig/${_config.options}/plain/${filePath}`;
  else cdnPath = `/sig/${_config.options}/plain/${filePath}@${_config.extension}`;

  return `${env.cdn.VITE_IMG_PROXY_URL}${cdnPath}`;
};
